import { Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { omit } from 'lodash-es';
import { Small as VoteAverageBadge } from '#components/VoteAverageBadge/index.tsx';
import { mapScreenTypeToSectionType } from '#helpers/enumMappers.ts';
import { tt } from '#i18n/index.ts';
import { Content, SupportingContent } from './styled.ts';
import { type TabTileProps } from './types.ts';

export const TabTile = (props: TabTileProps) => {
  const { renderTabImage, setActivePreview, sx, tab, ...rest } = props;
  const { id, subTitle, title, type, voteAverage } = tab;
  const theme = useTheme();
  const isSmallViewport = useMediaQuery(theme.breakpoints.down('sm'));

  const selectedStyles = {
    '& .voteAverageText': {
      color: theme.mainTextSecondary,
    },
    backgroundColor: theme.backgroundPrimary,
    boxShadow: `0 0 0 ${theme.spacing(1)} ${theme.backgroundPrimary}`,
    color: theme.mainTextSecondary,
  };

  return (
    <Tab
      disableRipple
      icon={renderTabImage(tab)}
      key={id}
      label={
        <Content>
          <Typography
            sx={{
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              display: '-webkit-box',
              overflow: 'hidden',
              textAlign: 'left',
            }}
            variant="body2"
          >
            {title}
          </Typography>
          <SupportingContent>
            <Typography
              className="listItemSubTitle"
              sx={{
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
                color: theme.supportingTextPrimary,
                display: '-webkit-box',
                overflow: 'hidden',
              }}
              variant="body2"
            >
              {subTitle ?? tt(`screenTypes.${type}`)}
            </Typography>
            {voteAverage ? <VoteAverageBadge voteAverage={voteAverage} /> : undefined}
          </SupportingContent>
        </Content>
      }
      onClick={() => {
        if (isSmallViewport) {
          setActivePreview?.({ id, type: mapScreenTypeToSectionType(type) });
        }
      }}
      sx={{
        '&.Mui-selected': {
          ...selectedStyles,
        },
        '&:hover,&:focus': {
          ...selectedStyles,
        },
        borderRadius: theme.spacing(0.5),
        color: theme.mainTextPrimary,
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(1.5),
        marginRight: theme.spacing(2.5),
        padding: 0,
        paddingBottom: theme.spacing(1),
        textTransform: 'none',
        ...sx,
      }}
      wrapped
      {...omit(rest, ['src', 'status'])}
    />
  );
};
